import { List, Map } from "immutable";
import { fixMediaUrl, parseFieldMetatags, processRichText } from "../../Shared/api/drupal/drupalApi";
import { collectionBlock } from "../../Shared/components/ContentBlocks/CollectionBlock/CollectionBlockApiConversion";
import { activityClusterBlock, booksOverviewBlock, buttonBlock, carouselContentGridBlock, collectionSearchBarBlock, contentGridBlock, ctaBlock, emptyBlock, faqBlock, featuredContentBlock, formstackBlock, gridBlock, highlightBlock, imagesBlock, mediaBlock, newsletterSignupBlock, pageGridBlock, quoteBlock, richTextBlock, subMenuBlock, subscriptionsBlock, themakiezerBlock, tippedActivitiesBlock, vacancyOverviewBlock, wordCloudBlock } from "./drupal_paragraph_to_block";
export const activityClustersPage = (n)=>{
    var _n_field_cta_primary_action, _n_field_cta_primary_action1, _n_field_cta_secondary_action, _n_field_cta_secondary_action1;
    return {
        kind: "activityClusters",
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media && fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]),
        imageUrlFallback: n.field_media && fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]),
        imageAlt: n.field_media && n.field_media.field_media_image.alt,
        coreActivityClusters: n.field_core_activity_clusters.map(coreActivityCluster).toList(),
        coreActivityAmount: n.field_kern_activiteiten_aantal ? parseInt(n.field_kern_activiteiten_aantal) : 3,
        regions: Map(),
        selectedPeriod: null,
        selectedRegion: null,
        selectedCluster: 'none',
        selectPeriod: null,
        selectRegion: null,
        toggleArchive: null,
        showArchive: false,
        ctaToggle: n.field_toggle_cta,
        ctaTitle: n.field_cta_title,
        ctaDescription: n.field_cta_description,
        ctaPrimaryActionTitle: (_n_field_cta_primary_action = n.field_cta_primary_action) === null || _n_field_cta_primary_action === void 0 ? void 0 : _n_field_cta_primary_action.title,
        ctaPrimaryActionUrl: (_n_field_cta_primary_action1 = n.field_cta_primary_action) === null || _n_field_cta_primary_action1 === void 0 ? void 0 : _n_field_cta_primary_action1.url,
        ctaSecondaryActionTitle: (_n_field_cta_secondary_action = n.field_cta_secondary_action) === null || _n_field_cta_secondary_action === void 0 ? void 0 : _n_field_cta_secondary_action.title,
        ctaSecondaryActionUrl: (_n_field_cta_secondary_action1 = n.field_cta_secondary_action) === null || _n_field_cta_secondary_action1 === void 0 ? void 0 : _n_field_cta_secondary_action1.url,
        activityPageState: null,
        setActivityState: null,
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    };
};
const coreActivityCluster = (c)=>({
        id: c.field_activity_cluster_id,
        title: c.field_title,
        description: c.field_text ? c.field_text : '',
        imageUrl: fixMediaUrl(c.field_image.field_media_image.image.style_urls["800w"]),
        imageUrlFallback: fixMediaUrl(c.field_image.field_media_image.image.style_urls["800w_fb"]),
        imageAlt: c.field_image.field_media_image.alt,
        linkUrl: c.field_link.url,
        linkText: c.field_link.title
    });
export const activityDetailPage = (n)=>({
        kind: "activityDetail",
        activityId: n.field_product_db_id,
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        subtitle: n.field_short_description,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]),
        imageAlt: n.field_media.field_media_image.alt,
        noticeTitle: n.field_notice_title,
        noticeContents: n.field_notice_contents,
        regions: Map(),
        selectedPeriod: null,
        selectedRegion: null,
        selectPeriod: null,
        selectRegion: null,
        blocks: generalContentPageBlocks(n.field_paragraphs),
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
export const collectionPage = (n)=>({
        kind: "collection",
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]),
        imageAlt: n.field_media.field_media_image.alt,
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : "",
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : "",
        header_blocks: generalContentPageBlocks(n.field_paragraphs_header),
        blocks: generalContentPageBlocks(n.field_paragraphs),
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
export const locationDetailPage = (n)=>({
        kind: "locationDetail",
        locationId: n.field_product_db_id,
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        subtitle: n.field_short_description,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]),
        imageAlt: n.field_media.field_media_image.alt,
        currentTitle: n.field_current_title,
        currentContents: n.field_current_contents ? processRichText(n.field_current_contents) : "",
        aboutTitle: n.field_about_title,
        aboutContents: n.field_about_contents ? processRichText(n.field_about_contents) : "",
        openingHours: n.field_location_opening_hours,
        blocks: generalContentPageBlocks(n.field_paragraphs),
        contactCustomerSupport: n.field_contact_customer_service ? processRichText(n.field_contact_customer_service) : "",
        email: n.field_email ?? "",
        phoneNumber: n.field_telefoonnummer ?? "",
        address: n.field_address,
        selectedLocationId: "0",
        branchLocations: [],
        selectLocation: undefined,
        googlePlacesId: n.field_google_placeid,
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
export const homePage = (n)=>({
        kind: "home",
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        headerButtonUrl: n.field_header_button_url ? n.field_header_button_url.url : "",
        headerButtonTitle: n.field_header_button_url ? n.field_header_button_url.title : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280w"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280w"]),
        imageAlt: n.field_media.field_media_image.alt,
        blocks: generalContentPageBlocks(n.field_paragraphs),
        showAnnouncement: n.field_show_announcement,
        announcement: n.field_announcement,
        selectedLocationId: "",
        selectLocation: undefined,
        branchLocations: [],
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
export const generalContentPage = (n)=>({
        kind: "generalContent",
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]) : "",
        imageUrlFallback: n.field_media ? fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]) : "",
        imageAlt: n.field_media ? n.field_media.field_media_image.alt : "",
        blocks: generalContentPageBlocks(n.field_paragraphs),
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
export const generalContentPageBlocks = (paragraphs)=>{
    return List(paragraphs.map((p)=>p.bundle == "text" ? richTextBlock(p) : p.bundle == "media" ? mediaBlock(p) : p.bundle == "faq_collection" ? faqBlock(p) : p.bundle == "highlight" ? highlightBlock(p) : p.bundle == "knop" ? buttonBlock(p) : p.bundle == "images" ? imagesBlock(p) : p.bundle == "content_grid" ? contentGridBlock(p) : p.bundle == "caroussel" ? carouselContentGridBlock(p) : p.bundle == "collection" ? collectionBlock(p) : p.bundle == "subscription_block" ? subscriptionsBlock(p) : p.bundle == "books" ? booksOverviewBlock(p) : p.bundle == "themakiezer_embed" ? themakiezerBlock(p) : p.bundle == "vacancy_overview" ? vacancyOverviewBlock(p) : p.bundle == "featured_content" ? featuredContentBlock(p) : p.bundle == "activity_cluster" ? activityClusterBlock(p) : p.bundle == "quote" ? quoteBlock(p) : p.bundle == "collection_search_bar" ? collectionSearchBarBlock(p) : p.bundle == "page_grid" ? pageGridBlock(p) : p.bundle == "grid_block" ? gridBlock(p) : p.bundle == "tipped_activities_block" ? tippedActivitiesBlock(p) : p.bundle == "wordcloud_block" ? wordCloudBlock(p) : p.bundle == "formstack_block" ? formstackBlock(p) : p.bundle == "cta_block" ? ctaBlock(p) : p.bundle == "newsletter_signup_form" ? newsletterSignupBlock(p) : p.bundle == "submenu" ? subMenuBlock(p) : p.bundle == "activities_selection_block" ? {
            kind: "activities_selection_block",
            ...p
        } : emptyBlock()));
};
export const activitySummary = (n)=>({
        headingLevel: 'h3',
        title: n.pageTitle,
        subtitle: n.subtitle,
        date: null,
        start: null,
        end: null,
        location: null,
        imageUrl: fixMediaUrl(n.imageUrl),
        imageUrlFallback: fixMediaUrl(n.imageUrlFallback),
        imageAlt: n.imageAlt,
        route: null,
        isTip: false
    });
export const reportOverview = (n)=>({
        kind: "reportOverview",
        pageTitle: n.label,
        headerTitle: n.field_header_title,
        description: n.field_description ? processRichText(n.field_description) : "",
        imageUrl: fixMediaUrl(n.field_media.field_media_image.image.style_urls["1280x720"]),
        imageUrlFallback: fixMediaUrl(n.field_media.field_media_image.image.style_urls["16x9"]),
        imageAlt: n.field_media.field_media_image.alt,
        jumboSize: n.field_jumbo_small ? "small" : "large",
        buttonUrl: n.field_header_button_url ? n.field_header_button_url.url : undefined,
        buttonTitle: n.field_header_button_url ? n.field_header_button_url.title : undefined,
        row_count: n.field_row_count ? n.field_row_count : 3,
        pageLanguage: parseFieldMetatags(n.field_meta_tags, 'og_locale', 'nl')
    });
